import { PageHero, Reveal } from "../components/Reveal";
import { IndustriesGrid } from "../components/Grids";
import { CTABanner } from "../components/CTABanner";
import { SectionHead } from "../components/Reveal";
import { IMAGES } from "../data/content";

export default function Industries() {
  return (
    <main data-testid="industries-page">
      <PageHero
        eyebrow="Industries We Serve"
        title="DIGITAL SOLUTIONS FOR EVERY INDUSTRY."
        sub="Startups, schools, hospitals, real estate, e-commerce and beyond — we've built growth systems for every kind of business."
      />

      <section className="bg-dg-light bg-grid-light py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <IndustriesGrid />
        </div>
      </section>

      <section className="relative bg-dg-navy py-24 sm:py-32 noise">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl shadow-black/40">
              <img src={IMAGES.building} alt="Modern institutional building representing DG Hubs industry clients" className="aspect-[4/3] w-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-dg-navy/80 via-transparent to-transparent" />
              <p className="absolute bottom-5 left-5 font-mono text-[11px] uppercase tracking-[0.25em] text-white/90">12+ Industries. One Hub.</p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <SectionHead
              eyebrow="Deep, Not Generic"
              title="Industry-Specific Playbooks"
              sub="A school needs admissions and a hospital needs trust — we don't run the same playbook twice. Every engagement starts with how your industry actually buys."
            />
            <ul className="-mt-4 space-y-3">
              {[
                "Education: admissions funnels + complete School ERP",
                "Healthcare: local SEO, reviews and patient-trust content",
                "Real Estate: project launch campaigns and site-visit funnels",
                "E-commerce: stores, shopping ads and retention systems",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm sm:text-base text-slate-300">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-dg-cyan" /> {t}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <CTABanner title="YOUR INDUSTRY. OUR PLAYBOOK." sub="Tell us your sector — we'll show you exactly how we'd grow it." />
    </main>
  );
}
